import React from 'react';
import { useToggleAiCopilotChatPanel } from '../ai/AiCopilotProvider';
import { MenuItem } from '../components/Menu';
import aiIcon from '../icons/non-prefilled/16x16/ai.svg';
import BetaBadge from '../organization/BetaBadge';

const AiCopilotMenuItem = () => {
  const toggleChatPanel = useToggleAiCopilotChatPanel();
  if (!toggleChatPanel) {
    return null;
  }

  return (
    <MenuItem
      onClick={toggleChatPanel}
      icon={aiIcon}
      right={<BetaBadge inline={false} />}
    >
      AI Copilot
    </MenuItem>
  );
};

export default AiCopilotMenuItem;
